import { defineStore } from 'pinia';

interface State {
    current?: number;
    listPlayable: number[];
    randomTimer?: any;
}

export const useMobileTeaserStore = defineStore('mobileTeaser', {
    state: (): State => ({
        current: undefined,
        listPlayable: [],
        randomTimer: undefined
    }),
    getters: {
        currentPlay(state: State) {
            if (state.listPlayable.length === 0) {
                return undefined;
            }

            return state.current;
        }
    },
    actions: {
        stopTimer(clear = true) {
            if (this.randomTimer) {
                clearInterval(this.randomTimer);
                this.randomTimer = undefined;
            }

            if (clear) {
                this.current = undefined;
            }
        },
        startTimer() {
            if (this.randomTimer) {
                clearInterval(this.randomTimer);
                this.randomTimer = undefined;
            }

            //if nothing playing
            if (this.current === undefined) {
                //this.setPlayable();
            }

            this.randomTimer = setInterval(() => {
                if (this.current) {
                    this.remove(this.current);
                    this.current = undefined;
                }
                this.setPlayable();
            }, 4000);
        },
        addPlayable(id: number) {
            const index = this.listPlayable.findIndex(p => p === id);
            if (index < 0) {
                this.listPlayable.push(id);
            }

            this.startTimer();
        },
        removePlayable(id: number) {
            if (id == this.current) {
                this.current = undefined;
            }

            this.remove(id);
            this.startTimer();
        },
        remove(id: number) {
            const index = this.listPlayable.findIndex(p => p === id);
            if (index != -1) {
                this.listPlayable.splice(index, 1);
            }
        },
        setPlayable() {
            if (this.listPlayable.length > 0) {
                const min = 0;
                const max = this.listPlayable.length - 1;
                const random = Math.floor(Math.random() * (max - min + 1) + min);
                this.current = this.listPlayable[random];
            } else {
                this.current = undefined;
            }
        }
    }
});
